var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertaBranco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.692,
    height: 24,
    viewBox: "0 0 19.692 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 19.692,
    height: 24,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.692,
    height: 24,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M17.2310028 16.6150055v-6.15299988c0-3.77799988-2.00600433-6.94200135-5.538002-7.77799988v-.8380127C11.6930008.82647705 10.8665161 0 9.84700011 0S8.00099945.82647705 8.00099945 1.84599304v.83700562c-3.51999664.83700561-5.53800201 3.98800659-5.53800201 7.77799988v6.15400695L0 19.07699585v1.2310028h19.69200134v-1.2310028l-2.46099853-2.46199036zM4.92299653 17.84599303h9.84600067v-7.38400268c0-3.0519867-1.8580017-5.53799439-4.92300415-5.53799439-3.06499481 0-4.92299652 2.4860077-4.92299652 5.53799439v7.38400268zM9.84600067 24c1.35813141-.00384521 2.45815277-1.10388184 2.46199799-2.46200562H7.38500214C7.38884735 22.8957367 8.48826599 23.99560547 9.84600067 24z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaBranco);
export default __webpack_public_path__ + "static/media/alerta_branco.dbace5ad0936374c847fe4fa2a4d2536.svg";
export { ForwardRef as ReactComponent };